import React, { createContext, useContext, useState } from 'react';
import Modal from './Modal';
import { AlertTriangleIcon } from '../icons';

// Confirm Dialog Context
const ConfirmContext = createContext();

export const useConfirm = () => {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error('useConfirm must be used within a ConfirmProvider');
  }
  return context;
};

// Confirm Provider Component
export const ConfirmProvider = ({ children }) => {
  const [confirmState, setConfirmState] = useState({
    isOpen: false,
    title: '',
    message: '',
    confirmText: '',
    cancelText: '',
    variant: 'danger',
    onConfirm: null,
    onCancel: null,
  });

  const confirm = ({
    title = 'Confirm Action',
    message = 'Are you sure you want to proceed?',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    variant = 'danger',
  }) => {
    return new Promise((resolve) => {
      setConfirmState({
        isOpen: true,
        title,
        message,
        confirmText,
        cancelText,
        variant,
        onConfirm: () => {
          setConfirmState((prev) => ({ ...prev, isOpen: false }));
          resolve(true);
        },
        onCancel: () => {
          setConfirmState((prev) => ({ ...prev, isOpen: false }));
          resolve(false);
        },
      });
    });
  };

  const handleClose = () => {
    if (confirmState.onCancel) {
      confirmState.onCancel();
    }
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      <Modal
        isOpen={confirmState.isOpen}
        onClose={handleClose}
        title={
          <>
            <AlertTriangleIcon
              style={{
                width: '20px',
                height: '20px',
                display: 'inline',
                verticalAlign: 'middle',
                marginRight: '8px',
              }}
            />
            {confirmState.title}
          </>
        }
        size="sm"
        closeOnOverlayClick={false}
        actions={[
          {
            label: confirmState.cancelText,
            onClick: confirmState.onCancel,
            variant: 'secondary',
          },
          {
            label: confirmState.confirmText,
            onClick: confirmState.onConfirm,
            variant: confirmState.variant,
          },
        ]}
      >
        <p style={{ margin: 0, lineHeight: 1.6 }}>{confirmState.message}</p>
      </Modal>
    </ConfirmContext.Provider>
  );
};

export default ConfirmProvider;
